import React from "react";
import CardHeader from "../../Components/shared/CardHeader";
import { Link } from "react-router-dom";
import useCardTitleActions from "../../hooks/useCardTitleActions";
import CardLoader from "../../Components/shared/CardLoader";
import { formatDateOnly } from "../../utils/options";

const LeadsStatusTwo = ({ leads, permission }) => {
  const {
    refreshKey,
    isRemoved,
    isExpanded,
    handleRefresh,
    handleExpand,
    handleDelete,
  } = useCardTitleActions();

  if (isRemoved) {
    return null;
  }
  const safeLeads = Array.isArray(leads) ? leads : [];
  const badgeColor = "warning";
  return (
    <div className="col-xxl-6">
      <div
        className={`card stretch stretch-full ${
          isExpanded ? "card-expand" : ""
        } ${refreshKey ? "card-loading" : ""}`}
      >
        <CardHeader
          title={"Leads Status"}
          refresh={handleRefresh}
          remove={handleDelete}
          expanded={handleExpand}
        />
        <div className="card-body custom-card-action p-0">
          <div className="table-responsive">
            <table className="table table-hover ">
              <thead>
                <tr>
                  <th scope="col">User</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Inquiry Type</th>
                  <th scope="col">Date</th>
                  <th scope="col">Assigned by</th>
                  <th scope="col">Created by</th>
                </tr>
              </thead>
              <tbody>
                {safeLeads.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No inquiry found.
                    </td>
                  </tr>
                ) : (
                  safeLeads.map((val, index) => (
                    <tr key={index} className="leads-status">
                      <td className="position-relative">
                        <div>
                          <div
                            className={`ht-50 position-absolute start-0 top-50 translate-middle rounded border-start border-5 border-${badgeColor}`}
                          ></div>
                          <span className="d-block fw-semibold text-capitalize">
                            {val.customer_name || ""}
                          </span>
                          <span className="d-block fs-12 text-muted">
                            {val.phone_number || ""}
                          </span>
                        </div>
                      </td>
                      <td>{val.loan_amount || ""}</td>
                      <td>
                        <span>{val.loan_type_name || ""}</span>
                      </td>
                      <td>
                        {val.inquiry_date
                          ? formatDateOnly(new Date(val.inquiry_date))
                          : ""}
                      </td>
                      <td>
                        <div>
                          <span className="d-block fw-semibold text-capitalize">
                            {val.assigned_name || ""}
                          </span>
                          <span className="d-block fs-12 text-muted">
                            {val.assigned_user_number || ""}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="bg-primary p-1 rounded">
                          <span className="d-block fw-semibold text-white text-capitalize">
                            {val.created_name || ""}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <CardLoader refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default LeadsStatusTwo;
